export const convertDate = (locale: string, date?: string): string | null => {
  if (!date) return null;
  return locale === 'en' ? convertToUsDate(date) : convertToIcelandicDate(date);
};

const convertToUsDate = (date: string): string => {
  const newDate = date.split('-').reverse();
  return newDate.join('.');
};

const convertToIcelandicDate = (date: string): string => {
  const monthsIcelandic = [
    'janúar',
    'febrúar',
    'mars',
    'apríl',
    'maí',
    'júní',
    'júlí',
    'ágúst',
    'september',
    'október',
    'nóvember',
    'desember',
  ];

  const [year, month, day] = date.split('-');
  const monthIndex = Number.parseInt(month, 10) - 1;
  const monthName = monthsIcelandic[monthIndex];

  return `${Number.parseInt(day, 10)}. ${monthName} ${year}`;
};
